import React from 'react';

import { FilterGrayChips } from './style';
import { IFilterChips } from './type';

const FilterGray = ({
	value,
	selected,
	setSelected = () => undefined,
	_disabled = false,
}: IFilterChips) => {
	return (
		<div>
			<FilterGrayChips
				selected={selected === value || selected.includes(value)}
				disabled={_disabled}
				onClick={() => {
					setSelected(value);
				}}
			>
				{value}
			</FilterGrayChips>
		</div>
	);
};

export default FilterGray;
